import React from "react";

import className from "../../style.module.scss";

export function SideBar(props) {
  return <div className={className.SideBar}>{props.children}</div>;
}

SideBar.propTypes = {};
SideBar.defaultProps = {};
